<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('accounts')"
      :columns="columns"
      :page_length="'1000'"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :extra_data="{ period_uuid: $route.params.period_uuid }"
      resource_url="/accounting/account/datatables"
      @data_loaded="data_loaded"
      ><template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="back"
          :data-tooltip="$t('back')"
        >
          <span class="icon">
            <i class="fa fa-arrow-left"></i>
          </span>
          <!-- <span>{{ $t("back") }}</span> -->
        </button>
        <button
          class="button is-secondary is-rounded"
          @click="update_balance"
          :data-tooltip="$t('update balance')"
        >
          <span class="icon">
            <i class="fa fa-balance-scale"></i>
          </span>
          <!-- <span>{{ $t("update balance") }}</span> -->
        </button>
        <button
          class="button is-secondary is-rounded"
          @click="save_template"
          :data-tooltip="$t('save as template')"
        >
          <span class="icon">
            <i class="fa fa-save"></i>
          </span>
          <!-- <span>{{ $t("save as template") }}</span> -->
        </button>
        <button
          class="button is-secondary is-rounded"
          @click="load_template"
          :data-tooltip="$t('load template')"
        >
          <span class="icon">
            <i class="fa fa-cubes"></i>
          </span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </template></generic-table
    >
    <div class="content">
      <ul>
        <li v-for="(root_account, ridx) in accounts" :key="ridx">
          <div class="title is-5 mb-2">
            {{ root_account.number }} - {{ root_account.name }}
            <span class="is-pulled-right">{{
              format_currency(root_account.balance)
            }}</span>
            <span
              class="is-pulled-right mr-2 has-text-primary"
              v-if="root_account.settings.balance_summary"
              >{{
                format_currency(root_account.settings.balance_summary.credit)
              }}</span
            >
            <span
              class="is-pulled-right mr-2 has-text-warning"
              v-if="root_account.settings.balance_summary"
              >{{
                format_currency(root_account.settings.balance_summary.debit)
              }}</span
            >
          </div>
          <ul>
            <li v-for="(account, aidx) in root_account.children" :key="aidx">
              <div class="title is-5 mb-2">
                {{ account.number }} - {{ account.name }}
                <span class="is-pulled-right">{{
                  format_currency(account.balance)
                }}</span>
                <span
                  class="is-pulled-right mr-2 has-text-primary"
                  v-if="root_account.settings.balance_summary"
                  >{{
                    format_currency(account.settings.balance_summary.credit)
                  }}</span
                >
                <span
                  class="is-pulled-right mr-2 has-text-warning"
                  v-if="root_account.settings.balance_summary"
                  >{{
                    format_currency(account.settings.balance_summary.debit)
                  }}</span
                >
              </div>
              <ul>
                <li
                  v-for="(sub_account, saidx) in account.children"
                  :key="saidx"
                >
                  <div class="title is-5 mb-2">
                    {{ sub_account.number }} - {{ sub_account.name }}
                    <span class="is-pulled-right">{{
                      format_currency(sub_account.balance)
                    }}</span>
                    <span
                      class="is-pulled-right mr-2 has-text-primary"
                      v-if="root_account.settings.balance_summary"
                      >{{
                        format_currency(
                          sub_account.settings.balance_summary.credit
                        )
                      }}</span
                    >
                    <span
                      class="is-pulled-right mr-2 has-text-warning"
                      v-if="root_account.settings.balance_summary"
                      >{{
                        format_currency(
                          sub_account.settings.balance_summary.debit
                        )
                      }}</span
                    >
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <!-- <pre>{{ accounts }}</pre> -->
    </div>
  </div>
  <account-modal
    ref="account_modal"
    @success="refresh"
    :current_period="current_period"
  />
  <transaction-list-modal ref="transaction_list_modal" />
  <load-template-modal ref="load_template_modal" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  success_message,
  del,
  input_alert,
  put,
  error_message,
  format_currency,
} from "@/utils";
import AccountModal from "./account_modal/Index.vue";
import TransactionListModal from "./transaction_list_modal/Index.vue";
import LoadTemplateModal from "./load_template_modal/Index.vue";

export default {
  name: "AccountsDatatable",
  components: {
    GenericTable,
    AccountModal,
    TransactionListModal,
    LoadTemplateModal,
  },
  props: {
    current_period: {
      type: Object,
      required: false,
    },
  },
  data() {
    let v = this;
    return {
      extra_buttons: [],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="title is-6">${row.number}</div>
                    <div class="subtitle is-6 mb-0">${row.name}</div>`;
          },
        },
        {
          title: v.$t("type"),
          name: "name",
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="title is-6">${v.$t(row.type)}</div>
                    <div class="subtitle is-6 mb-0">${v.$t(row.target)}</div>`;
          },
        },
        {
          title: v.$t("balance"),
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return `${format_currency(row.balance || "")} (${
            //   row.number_of_transactions
            // } trx)`;
            let r = `<div class="title is-6">${format_currency(
              row.balance
            )}</div>`;
            if (row.settings.balance_summary) {
              r += `<div class="subtitle is-6 mb-0">${format_currency(
                row.settings.balance_summary.credit
              )} ${v.$t("credit")}</div>
             <div class="subtitle is-6 mb-0">${format_currency(
               row.settings.balance_summary.debit
             )} ${v.$t("debit")}</div><div class="subtitle is-6 mb-0">${
                row.number_of_transactions
              } ${v.$t("transactions")}</div>`;
            }
            return r;
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   // width: "10%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return format_currency(row.balance) || "";
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.account_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("create account"),
                icon: "fa fa-plus",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.account_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("transaction list"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.transaction_list_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete account?"),
                    v,
                    () => {
                      del("/accounting/account", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
      accounts: [],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.account_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    back() {
      let v = this;
      v.$router.push({
        path: `/accounting/${v.$route.params.period_uuid}`,
      });
    },
    update_balance() {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to update accounts balance?"),
        v,
        () => {
          v.$root.loader(true);
          put("/accounting/account/balance", {
            uuid: v.$route.params.period_uuid,
          })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            })
            .finally(() => {
              v.$root.loader(false);
            });
        }
      );
    },
    data_loaded(data) {
      let v = this;
      let tree = v.build_tree(data);
      v.accounts = tree;
    },
    build_tree(data) {
      let v = this;
      let tree = [];
      let root_nodes = data.filter((node) => !node.parent_account);
      root_nodes.map((node) => {
        let n = { ...node };
        n.children = v.get_children(node, data);
        tree.push(n);
      });
      return tree;
    },
    get_children(node, data) {
      let v = this;
      let children = data.filter(
        (child) =>
          child.parent_account && child.parent_account.uuid === node.uuid
      );
      children.map((child) => {
        child.children = v.get_children(child, data);
      });
      return children;
    },
    save_template() {
      let v = this;
      let options = {
        input: "text",
        title: v.$t("name for template"),
        confirm_text: v.$t("save"),
        cancel_text: v.$t("cancel"),
      };
      input_alert(options).then((value) => {
        put("/accounting/account/template", {
          uuid: v.$route.params.period_uuid,
          name: value,
        })
          .then(() => {
            success_message(v.$t("accounts saved as template"));
          })
          .catch((error) => {
            error_message(error);
          });
      });
      // confirm_deletion_dialog(
      //   v.$t("are you sure to save accounts as template?"),
      //   v,
      //   () => {
      //     v.$root.loader(true);
      //     put("/accounting/account/template", {
      //       uuid: v.$route.params.period_uuid,
      //     })
      //       .then(() => {
      //         success_message(v.$t("accounts saved as template"));
      //       })
      //       .catch((error) => {
      //         error_message(error);
      //       })
      //       .finally(() => {
      //         v.$root.loader(false);
      //       });
      //   }
      // );
    },
    load_template() {
      let v = this;
      v.$refs.load_template_modal.show_modal();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
